import * as Yup from 'yup'

export const schemaOrderPaymentsPaidAt = (t: (key: string) => string) => ({
  payments: Yup.array().of(
    Yup.object().shape({
      uuid: Yup.string().required(t('requiredMessage')),
      paidAt: Yup.string().required(t('requiredMessage')),
      status: Yup.string().required(t('requiredMessage')),
    }),
  ),
})
